import { CasesdeSucessoContentCollection } from 'modules/casesdesucesso/Articles/Articles.types';
import { Intern } from 'modules/casesdesucesso/Intern';
import { Footer } from 'modules/common/Footer';
import { FooterCollection } from 'modules/common/Footer/Footer.types';
import { Header } from 'modules/common/Header';
import { HeaderCollection } from 'modules/common/Header/Header.types';

import contentfulData from '../../services/contentful';
import { queryCase } from '../../services/contentful/querys';

type IntegrationsProps = {
  menuPrincipal: HeaderCollection;
  menuRodape: FooterCollection;
  casesdesucesso: CasesdeSucessoContentCollection;
};

const CasedesucessoPage = ({ casesdesucesso, menuPrincipal, menuRodape }: IntegrationsProps) => {
  return (
    <div>
      <Header menus={menuPrincipal.menus} />
      <main>
        <Intern items={casesdesucesso.items} />
      </main>

      <Footer menus={menuRodape.menus} />
    </div>
  );
};

export default CasedesucessoPage;

export async function getServerSideProps({ params }: any) {
  const data: CasesdeSucessoContentCollection = await contentfulData(
    queryCase(params.slug ? `/${params.slug}` : '')
  );

  return {
    props: data,
  };
}
